/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './diag-lab-inventory-checkout.reducer';

export const DiagLabInventoryCheckout = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const diagLabInventoryCheckoutList = useAppSelector(state => state.diagLabInventoryCheckout.entities);
  const loading = useAppSelector(state => state.diagLabInventoryCheckout.loading);
  const totalItems = useAppSelector(state => state.diagLabInventoryCheckout.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="diag-lab-inventory-checkout-heading" data-cy="DiagLabInventoryCheckoutHeading">
        <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.home.title">Diag Lab Inventory Checkouts</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/diag-lab-inventory-checkout/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.home.createLabel">
              Create new Diag Lab Inventory Checkout
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.diagLabInventoryCheckout.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {diagLabInventoryCheckoutList && diagLabInventoryCheckoutList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('brandId')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.brandId">Brand Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('brandId')} />
                </th>
                <th className="hand" onClick={sort('batchNumber')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.batchNumber">Batch Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('batchNumber')} />
                </th>
                <th className="hand" onClick={sort('serialNumber')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.serialNumber">Serial Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('serialNumber')} />
                </th>
                <th className="hand" onClick={sort('remainingUses')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.remainingUses">Remaining Uses</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remainingUses')} />
                </th>
                <th className="hand" onClick={sort('avgUsesPerItem')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.avgUsesPerItem">Avg Uses Per Item</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('avgUsesPerItem')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.diagLab">Diag Lab</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.type">Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.inventory">Inventory</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {diagLabInventoryCheckoutList.map((diagLabInventoryCheckout, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/diag-lab-inventory-checkout/${diagLabInventoryCheckout.id}`} color="link" size="sm">
                      {diagLabInventoryCheckout.id}
                    </Button>
                  </td>
                  <td>{diagLabInventoryCheckout.brandId}</td>
                  <td>{diagLabInventoryCheckout.batchNumber}</td>
                  <td>{diagLabInventoryCheckout.serialNumber}</td>
                  <td>{diagLabInventoryCheckout.remainingUses}</td>
                  <td>{diagLabInventoryCheckout.avgUsesPerItem}</td>
                  <td>{diagLabInventoryCheckout.active ? 'true' : 'false'}</td>
                  <td>{diagLabInventoryCheckout.cursor}</td>
                  <td>{diagLabInventoryCheckout.lastUpdated}</td>
                  <td>{diagLabInventoryCheckout.microSec}</td>
                  <td>{diagLabInventoryCheckout.timestampEntry}</td>
                  <td>
                    {diagLabInventoryCheckout.diagLab ? (
                      <Link to={`/diag-lab/${diagLabInventoryCheckout.diagLab.id}`}>{diagLabInventoryCheckout.diagLab.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diagLabInventoryCheckout.type ? (
                      <Link to={`/diag-lab-inventory-type/${diagLabInventoryCheckout.type.id}`}>{diagLabInventoryCheckout.type.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diagLabInventoryCheckout.inventory ? (
                      <Link to={`/diag-lab-inventory/${diagLabInventoryCheckout.inventory.id}`}>
                        {diagLabInventoryCheckout.inventory.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/diag-lab-inventory-checkout/${diagLabInventoryCheckout.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/diag-lab-inventory-checkout/${diagLabInventoryCheckout.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/diag-lab-inventory-checkout/${diagLabInventoryCheckout.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.home.notFound">
                No Diag Lab Inventory Checkouts found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={diagLabInventoryCheckoutList && diagLabInventoryCheckoutList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DiagLabInventoryCheckout;
